export default __webpack_public_path__ + "images/cancerfondsrapporten/calendar-6.png";